// extracted by mini-css-extract-plugin
export default {"container":"RegionFilter_container__4c94g","content":"RegionFilter_content__kLNuF"};